export enum ContractIntervalEnum {
	Weekly = 0,
	Monthly = 10,
	Quarterly = 20,
	HalfYearly = 30,
	Yearly = 40
}
